var map = {
	"./bigFont.svg": "3f42",
	"./bold.svg": "58f9",
	"./delete-table.svg": "6a71",
	"./dropdown.svg": "40f6",
	"./equation.svg": "5ded",
	"./image-icon.svg": "05b5",
	"./italic.svg": "68a3",
	"./orderedList.svg": "05a1",
	"./smallFont.svg": "2ff5b",
	"./strikethrough.svg": "4ad0",
	"./subscript.svg": "61eb",
	"./superscript.svg": "97aa",
	"./tableColor.svg": "53b4",
	"./textColor.svg": "40df",
	"./underline.svg": "e018",
	"./unorderedList.svg": "da37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9dea";